module.exports = __webpack_public_path__ + "img/increment.5dd3dc68.svg";